import { AuthPage } from "./AuthPage.tsx";

export default function SignUpPage() {
  return <AuthPage mode="signup" />;
}
